import { Component, ViewEncapsulation } from '@angular/core';
import { ToastNotificationService } from '../../../core/toast-notification.service';
import { UIBlockingService } from '../../../core/ui-blocking.service';
import { MemberInformationService } from '../member-information.service';
import { DumbMemberNewsArticle, MemberNewsSearchResult } from '../DTOs/dumb-member-news-article';
import { GetMemberNewsSearchRequest } from '../DTOs/get-member-news-search-request';
import { Observable, merge } from 'rxjs';
import { DumbMemberListItem } from '../../../super-admin-member-management/DTOs/dumb-member-list-item';
import { DumbPublicMember } from '../DTOs/dumb-public-member';
import { NgbDropdown } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-member-news',
  templateUrl: './member-news-feed.component.html',
  providers: [UIBlockingService, NgbDropdown],
  encapsulation: ViewEncapsulation.None
})
export class MemberNewsFeedComponent {
  constructor(private memberInformationService: MemberInformationService
    , private blockUI: UIBlockingService
    , private notificationService: ToastNotificationService) {
  }
  membersWithNews = [];
  memberSearch = 0;
  timeSearch = 0;
  searchText = "";
  page: number = 1;
  totalResults: number = 0;
  itemsPerPage: number = 8;
  articles: DumbMemberNewsArticle[] = [];
  latestNews: DumbMemberNewsArticle = new DumbMemberNewsArticle();
  totalPages = 0;
  initialLoad = true;


  get currentPageNum() { return this.page };
  set currentPageNum(page: number) {
    this.page = page;
    console.log(this.initialLoad)
    if (!this.initialLoad)
      this.searchNews();
  }

  ngOnInit() {
    this.blockUI.start();

    this.getMemberNames().subscribe(
      {
        next: (data) => {
          this.membersWithNews = data;
        },
        error: (err) => {
          this.notificationService.error(err.error.message);
          this.blockUI.stop();
          console.log(err)
        },
        complete: () => {
        }
      });
    this.searchNewsObservable().subscribe(
      {
        next: (data) => {
          this.totalResults = data.totalResults;
          this.articles = data.articles;
          this.latestNews = data.latestNews;
        },
        error: (err) => {
          this.notificationService.error(err.error.message);
          this.blockUI.stop();
          console.log(err)
        },
        complete: () => {
          this.blockUI.stop();
        }
      });
  }

  getMemberNames(): Observable<DumbPublicMember[]> {
    return this.memberInformationService
      .getDumbListOfMembersWithNews();
  }

  searchNewsObservable(): Observable<MemberNewsSearchResult> {
    var req = new GetMemberNewsSearchRequest(this.memberSearch, this.timeSearch, this.searchText, this.currentPageNum - 1);
    this.initialLoad = false;
    return this.memberInformationService
      .searchNewsArticles(req);
  }

  searchNews(clearResults = false) {
    this.blockUI.start();

    this.searchNewsObservable()
      .subscribe(
        {
          next: (data) => {
            this.initialLoad = false;

            this.articles = data.articles;
            this.latestNews = data.latestNews;
          },
          error: (err) => {
            this.notificationService.error(err.error.message);
            this.blockUI.stop();
            console.log(err)
          },
          complete: () => {
            this.blockUI.stop();
          }
        });
  }

}
